import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useForm } from 'react-hook-form';
import { Link, Redirect } from 'react-router-dom'

import AppContext from '../../../contexts/AppContext'

import useToastContext from '../../../hooks/useToastContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faKey, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons'

const LeadForm = ({ initLead, onUpdated, onCreated, onDeleted }) => {

    const { data, leadServices } = useContext(AppContext)
    const { user } = data.app
    const [ loading, setLoading ] = useState(false)

    const { register, handleSubmit, watch, errors, setError, reset } = useForm({
        defaultValues: initLead
    });

    const addToast = useToastContext()

    const errorMessages = data => {
        if(data){
            if(data.message) addToast({title: 'Error', message: data.message, type: 'danger'})
            if(data.errors){
                const keys = Object.keys(data.errors)
                for(var i = 0; i < keys.length; i ++){
                    setError(keys[i], { type: "manual", message: data.errors[keys[i]].join('. ')})
                }
            }
        }
    }

    const onSubmit = data => {

        if(data.id){
            setLoading(true)
            leadServices.update(data).then(res => {
                setLoading(false)
                addToast({title: 'Success', message: 'Lead successfully updated', type: 'success'})
                if(typeof onUpdated == 'function') onUpdated(res)
            }).catch(res => {
                setLoading(false)
                errorMessages(res.data)
            })
        }else{
            setLoading(true)
            leadServices.create(data).then(res => {
                setLoading(false)
                addToast({title: 'Success', message: 'Lead successfully created', type: 'success'})
                if(typeof onCreated == 'function') onCreated(res)
            }).catch(res => {
                setLoading(false)
                errorMessages(res.data)
            })
        }
    };

    return (

        <div className="card">
            <form className="card-body" onSubmit={handleSubmit(onSubmit)}>
                <input type="hidden" name="id" readOnly ref={register} />

                <h3>Lead information</h3>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="leadOwnerId" className="lbl-sm">Lead owner</label>
                            <input
                                className="form-control"
                                id="leadOwnerId"
                                type="text"
                                value={user.full_name}
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="leadTypdId" className="lbl-sm">Lead type<sup>*</sup></label>
                            <select
                                id="leadTypdId"
                                className="custom-select custom-select"
                                defaultValue=""
                                name="type"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="business">Business</option>
                                <option value="personal">Personal</option>
                            </select>
                            {errors.type && <div className="invalid-feedback d-block">{errors.type.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="leadStatusId" className="lbl-sm">Lead status<sup>*</sup></label>
                            <select
                                id="leadStatusId"
                                className="custom-select custom-select"
                                defaultValue=""
                                name="status"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="new">New</option>
                                <option value="contacted">Contacted</option>
                                <option value="working">Working</option>
                                <option value="qualified">Qualified</option>
                                <option value="unqualified">Unqualified</option>
                            </select>
                            {errors.status && <div className="invalid-feedback d-block">{errors.status.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="leadPhoneId" className="lbl-sm">Phone number</label>
                            <input
                                id="leadPhoneId"
                                type="text"
                                className="form-control"
                                name="phone"
                                placeholder="Phone number"
                                defaultValue=""
                                ref={register}
                            />
                            {errors.phone && <div className="invalid-feedback d-block">{errors.phone.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="salutationId" className="lbl-sm">Salutation</label>
                            <select
                                id="salutationId"
                                className="custom-select custom-select"
                                defaultValue=""
                                name="salutation"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="mr">Mr.</option>
                                <option value="ms">Ms</option>
                                <option value="mrs">Mrs.</option>
                                <option value="dr">Dr.</option>
                                <option value="prof">Prof.</option>
                            </select>
                            {errors.salutation && <div className="invalid-feedback d-block">{errors.salutation.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="nameId" className="lbl-sm">Contact name<sup>*</sup></label>
                            <input
                                id="nameId"
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Contact name"
                                ref={register}
                            />
                            {errors.name && <div className="invalid-feedback d-block">{errors.name.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="emailId" className="lbl-sm">Email</label>
                            <input
                                id="emailId"
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Email"
                                ref={register}
                            />
                            {errors.email && <div className="invalid-feedback d-block">{errors.email.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="companyId" className="lbl-sm">Company</label>
                            <input
                                id="companyId"
                                type="text"
                                className="form-control"
                                name="company"
                                placeholder="Company"
                                ref={register}
                            />
                            {errors.company && <div className="invalid-feedback d-block">{errors.company.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="titleId" className="lbl-sm">Title</label>
                            <input
                                id="titleId"
                                type="text"
                                className="form-control"
                                name="title"
                                placeholder="Title"
                                ref={register}
                            />
                            {errors.title && <div className="invalid-feedback d-block">{errors.title.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="ratingId" className="lbl-sm">Rating</label>
                            <select
                                id="ratingId"
                                className="custom-select custom-select"
                                name="rating"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="hot">Hot</option>
                                <option value="warm">Warm</option>
                                <option value="cold">Cold</option>
                            </select>
                            {errors.rating && <div className="invalid-feedback d-block">{errors.rating.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="addressId" className="lbl-sm">Address</label>
                            <input
                                id="addressId"
                                type="text"
                                className="form-control"
                                name="address"
                                placeholder="Address"
                                ref={register}
                            />
                            {errors.address && <div className="invalid-feedback d-block">{errors.address.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="websiteId" className="lbl-sm">Website</label>
                            <input
                                id="websiteId"
                                type="text"
                                className="form-control"
                                name="website"
                                placeholder="Website"
                                ref={register}
                            />
                            {errors.website && <div className="invalid-feedback d-block">{errors.website.message}</div>}
                        </div>
                    </div>

                </div>

                <hr />

                <h4>Additional information</h4>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="sourceId" className="lbl-sm">Lead Source</label>
                            <select
                                id="sourceId"
                                className="custom-select custom-select"
                                defaultValue=""
                                name="source"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="advertisement">Advertisement</option>
                                <option value="employee">Employee Referral</option>
                                <option value="external">External Referral</option>
                                <option value="in-store">In-Store</option>
                                <option value="on-site">On Site</option>
                                <option value="other">Other</option>
                                <option value="social">Social</option>
                                <option value="trade-show">Trade Show</option>
                                <option value="web">Web</option>
                                <option value="word-of-mouth">Word of mouth</option>
                            </select>
                            {errors.source && <div className="invalid-feedback d-block">{errors.source.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label htmlFor="industryId" className="lbl-sm">Industry</label>
                            <select
                                id="industryId"
                                className="custom-select custom-select"
                                defaultValue=""
                                name="industry"
                                ref={register}
                            >
                                <option value="">--None--</option>
                                <option value="agriculture">Agriculture</option>
                                <option value="apparel">Apparel</option>
                                <option value="banking">Banking</option>
                                <option value="biotechnology">Biotechnology</option>
                                <option value="chemicals">Chemicals</option>
                                <option value="communications">Communications</option>
                                <option value="construction">Construction</option>
                                <option value="consulting">Consulting</option>
                                <option value="education">Education</option>
                                <option value="electronics">Electronics</option>
                                <option value="energy">Energy</option>
                                <option value="engineering">Engineering</option>
                                <option value="entertainment">Entertainment</option>
                                <option value="environmental">Environmental</option>
                                <option value="finance">Finance</option>
                                <option value="food &amp; Beverage">Food &amp; Beverage</option>
                                <option value="government">Government</option>
                                <option value="healthcare">Healthcare</option>
                                <option value="hospitality">Hospitality</option>
                                <option value="insurance">Insurance</option>
                                <option value="machinery">Machinery</option>
                                <option value="manufacturing">Manufacturing</option>
                                <option value="media">Media</option>
                                <option value="not-for-profit">Not For Profit</option>
                                <option value="other">Other</option>
                                <option value="realestate">Real Estate</option>
                                <option value="recreation">Recreation</option>
                                <option value="retail">Retail</option>
                                <option value="shipping">Shipping</option>
                                <option value="technology">Technology</option>
                                <option value="telecommunications">Telecommunications</option>
                                <option value="transportation">Transportation</option>
                                <option value="utilities">Utilities</option>
                            </select>
                            {errors.industry && <div className="invalid-feedback d-block">{errors.industry.message}</div>}
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="mb-3">
                            <label htmlFor="descriptionId" className="lbl-sm">Description</label>
                            <textarea
                                rows="7"
                                id="descriptionId"
                                ref={register}
                                className="form-control"
                                name="description"
                                placeholder="Description"
                            ></textarea>
                            {errors.description && <div className="invalid-feedback d-block">{errors.description.message}</div>}
                        </div>
                    </div>

                </div>

                <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                        {loading && <FontAwesomeIcon icon={faSpinner} className="fa-spin" />}
                        {!loading && <FontAwesomeIcon icon={faCloudDownloadAlt} />}
                        <span className="ms-2">
                            {initLead ? 'Save' : 'Create'}
                        </span>
                    </button>
                </div>

            </form>

        </div>

    )
}

export {
    LeadForm
}